<template>
    <v-container grid-list-md>
        <v-dialog v-model="edit.showModal"  max-width="600px">
            <v-card>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <h2>Tarieven</h2>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn color="green darken-1" class="white--text" @click.native="addPrice()">Toevoegen</v-btn>
                            <v-data-table
                                v-bind:headers="headers"
                                v-bind:items="reservation.costData.prices"
                                hide-actions
                                :rows-per-page-items="[25,50]"
                                item-key="id"
                                >
                                <template slot-scope="props">
                                <tr>
                                    <th v-for="header in props.headers" :key="header.text"
                                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                    @click="changeSort(header.value)"
                                    >
                                    <v-icon>arrow_upward</v-icon>
                                    {{ header.text }}
                                    </th>
                                </tr>
                                </template>
                                <template slot="items" slot-scope="props">
                                <tr>
                                    <td class="text-xs-left" @click="editPrice(props.item, props.index)">
                                       {{ props.item.hours }}
                                    </td>
                                    <td class="text-xs-left" @click="editPrice(props.item, props.index)">
                                       {{getTimeUnitDescription(props.item.timeUnit)}}
                                    </td>
                                    <td class="text-xs-left" @click="editPrice(props.item, props.index)">
                                        {{ props.item.price }}
                                    </td>
                                    <td class="text-xs-left" @click="editPrice(props.item, props.index)">
                                       {{ props.item.kmFree }}
                                    </td>
                                    <td class="justify-center text-xs-left" v-if="reservation.costData.customPrices">
										<v-icon color="gray" class="mr-2" @click="editPrice(props.item, props.index)" small>edit</v-icon>
										<v-icon color="pink" @click="deletePrice(props.item, props.index)" small>delete</v-icon>
                                    </td>
                                </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-btn color="gray darken-1" flat="flat" @click.native="edit.showModal = false;">Sluiten</v-btn>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addPriceDialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Tarief toevoegen</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Aantal" required v-model="newPrice.hours"></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Prijs" required v-model="newPrice.price"></v-text-field>
                  </v-flex>
				   <v-flex xs12 sm6 md6>
                    <v-menu offset-y>
                        <v-btn slot="activator">{{getTimeUnitDescription(newPrice.timeUnit)}}</v-btn>
                        <v-list>
                            <v-list-tile v-for="(item, index) in timeOptions" :key="index" v-model="newPrice.timeUnit" @click="newPrice.timeUnit = item.value">
                            <v-list-tile-title>{{ getTimeUnitDescription(item.value) }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field label="Km vrij" required v-model="newPrice.kmFree"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="addPriceDialog = false">Annuleren</v-btn>
              <v-btn color="blue darken-1" flat @click="saveNewPrice()">Opslaan</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

		<v-dialog v-model="editPriceDialog" max-width="500px">
			<v-card>
				<v-card-title>
					<span class="headline">Bewerk prijs</span>
				</v-card-title>

				<v-card-text>
					<v-container grid-list-md>
					<v-layout wrap>
						<v-flex xs12 sm6 md6>
						<v-text-field type="number" min="0" step="1" v-model="editedItem.hours" label="Aantal"></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 md6>
						<v-text-field  type="number" min="0" step="0.01" v-model="editedItem.price" label="Prijs"></v-text-field>
						</v-flex>
						<v-flex xs12 sm6 md6>
						<v-menu offset-y>
							<v-btn slot="activator">{{getTimeUnitDescription(editedItem.timeUnit)}}</v-btn>
							<v-list>
								<v-list-tile v-for="(item, index) in timeOptions" :key="index" @click="updateTimeUnit(editedItem, item.value)">
								<v-list-tile-title>{{ item.text }}</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
						</v-flex>
						<v-flex xs12 sm6 md6>
						<v-text-field type="number" min="0" step="1" v-model="editedItem.kmFree" label="Km vrij"></v-text-field>
						</v-flex>
					</v-layout>
					</v-container>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="blue darken-1" flat @click="closeEditPrice">Annuleren</v-btn>
					<v-btn color="blue darken-1" flat @click="saveEdit">Opslaan</v-btn>
				</v-card-actions>
			</v-card>
      	</v-dialog>
    </v-container>
</template>
<script>
import * as utils from "@/utils/utils";
import { _ } from "vue-underscore";

export default {
  name: "ReservationPrices",
  props: ["reservation", "editable", "edit"],
  utils: utils,
  data() {
    return {
      items: [],
      headers: [
        { text: "Aantal", value: "hours", class: "" },
        { text: "Eenheid", value: "timeUnit", class: "" },
        { text: "Bedrag", value: "price", class: "" },
        { text: "Km vrij", value: "kmFree", class: "" },
        { text: "Opties", value: "hours", class: "", sortable: false }
      ],
      timeOptions: [
        {
          value: "hour",
          text: "uur"
        },
        {
          value: "day",
          text: "dag"
        },
        {
          value: "week",
          text: "week"
        },
        {
          value: "month",
          text: "maand"
        }
      ],
      addPriceDialog: false,
      newPrice: {
        hours: 0,
        timeUnit: "hour",
        price: 0,
        kmFree: 0
	  },
	  editedIndex: 0,
	  editedItem: {},
	  editPriceDialog: false
    };
  },
  methods: {
    deletePrice(priceItem, index) {
      let self = this;
      priceItem.reservationId = this.reservation.id;
      if (priceItem.rentPriceId) {
        utils
          .setData(
            basePath + "api/reservations/deleteReservationPrice/",
            priceItem
          )
          .then(function(json) {
            self.reservation.costData.prices = _.without(
              self.reservation.costData.prices,
              _.findWhere(self.reservation.costData.prices, {
                rentPriceId: priceItem.rentPriceId
              })
            );
          });
      } else {
        self.reservation.costData.prices.splice(
          self.reservation.costData.prices.length - 1,
          1
        );
      }
    },
    addPrice() {
      this.newPrice = {
        hours: 0,
        timeUnit: "hour",
        price: 0,
        kmFree: 0
      }
      this.addPriceDialog = true;
	},
	editPrice(item) {
 		this.editedIndex = this.reservation.costData.prices.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.editPriceDialog = true
	},
    saveNewPrice() {
      this.reservation.costData.prices.push(this.newPrice);
      this.addPriceDialog = false;
    },
    updateTimeUnit(item, value) {
      item.timeUnit = value;
    },
    getTimeUnitDescription(timeUnit) {
      let data = _.where(this.timeOptions, { value: timeUnit });
      if (data && data.length) {
        return data[0]["text"];
      } else {
        return "";
      }
	},
	saveEdit() {
  		if (this.editedIndex > -1) {
          Object.assign(this.reservation.costData.prices[this.editedIndex], this.editedItem)
        } else {
          this.reservation.costData.prices.push(this.editedItem)
		}
		this.closeEditPrice();
	},
	closeEditPrice() {
		this.editPriceDialog = false;
	}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reservations/ReservationPrices.vue